export default __webpack_public_path__ + "84b70287f8d85a07bdaffafcba12ef41.png";